import { filterTruthy } from './util';
import { DecimalPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Get price nicely formatted.
 * @param price The price to format
 * @param decimalPipe For formatting the number
 * @returns The price string
 */
export function getPriceString(price: string | undefined, decimalPipe: DecimalPipe): string {
	if (price === '0.00') return $localize`:@@PaymentMethodFree:Free!`;
	return `${decimalPipe.transform(price, '1.2-2') || 'ERROR'} €`;
}

/**
 * Get premedia price nicely formatted.
 * @param pricePool$ The price pool to get the price from
 * @param decimalPipe For formatting the number
 * @param priceKey The key of the price
 * @returns The price string
 */
export function getPreMediaPrice$(
	pricePool$: Observable<Record<string, string> | undefined>,
	decimalPipe: DecimalPipe,
	priceKey: string,
): Observable<string> {
	return pricePool$.pipe(
		filterTruthy,
		map((val) => getPriceString(val[priceKey], decimalPipe)),
	);
}
